import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/toastWarning.svg',
})
export class ToastWarningComponent {}
